<div class="sideStyle">
    <div style="height: 100vh; width: 53px; min-width: 53px;" class="sideBtn" *ngIf="isShowSideBtn">
        <button pButton pRipple type="button" pTooltip="Accounts" tooltipPosition="right" class="p-button-rounded"
            label="A" (click)="navigateToAccount()" style="margin-bottom: 10px;" *ngIf="isShowSideBtn"
            [ngClass]="{'p-button-secondary': showSharedContacts}"></button>
        <button pButton pRipple type="button" pTooltip="Account Contacts" tooltipPosition="right"
            class="p-button-rounded" label="C" (click)="toggleAccountContacts()" *ngIf="isShowSideBtn"
            [ngClass]="{'p-button-secondary': !showSharedContacts}"></button>
    </div>

    <ng-container *ngIf="showSharedContacts; else existingAccount">
        <app-shared-contacts-v1 [associationTypeName]="associationTypeName"
        [isShowSideBtn]="isShowSideBtn" (changeSideHeader)="changeSideHeader($event)"></app-shared-contacts-v1>
    </ng-container>
    <ng-template #existingAccount>
        <div [style.width]="isShowSideBtn ? 'calc(100% - 53px)' : '100%'">
            <div class="p-grid">
                <!-- Menu Bar -->
                <div class="p-col-12" [ngClass]="{'p-d-none': !(!isDetailsShowing && isMenuShow)}">
                    <p-menubar [model]="menuItems" styleClass="top-menu submenu-align-right">
                        <ng-template pTemplate="start" style="width: 100%;">
                            <span class="btnBars" (click)="isShowSideBtn = !isShowSideBtn;changeFloathead()" style="vertical-align: sub;">
                                <i class="pi pi-angle-double-left" *ngIf="isShowSideBtn"></i>
                                <i class="pi pi-angle-double-right" *ngIf="!isShowSideBtn"></i>
                            </span>
                            <h2 style="display: inline;">Accounts - </h2>
                            <span *ngIf="!hideChannelDropdown" style="width: fit-content; ">
                                <p-dropdown placeholder="Choose Channel" [options]="channelsN"
                                    (onChange)="changeChannel()" [(ngModel)]="selectedChannelN" optionLabel="name"
                                    appendTo="body" class="customDD" [baseZIndex]="0">
                                </p-dropdown>
                            </span>
                            <span style="width: fit-content;">
                                <p-toggleButton class="p-mb-2 p-ml-2" onLabel="Active" offLabel="InActive"
                                    [onIcon]="'pi pi-check'" [offIcon]="'pi pi-times'" iconPos="right"
                                    [(ngModel)]="isActive" (onChange)="loadListingWithFilters()">
                                </p-toggleButton>
                            </span>
                            <span class="p-input-icon-left" style="float: right; margin-left: 5px;">
                                <i class="pi pi-search searchPosition"></i>
                                <input type="text" style="float: right; margin: 2px 5px 0px 0px;" pInputText
                                    placeholder="Search..." [formControl]="searchControl" />
                            </span>
                            <!-- <span style="float: right; margin-top: 1px;">
                                <p-dropdown #dd [options]="recentItems" id="recentItems" (onChange)="loadListingWithFilters()"
                                    [(ngModel)]="selectedRecent" optionLabel="name" appendTo="body" class="customDD"
                                    [baseZIndex]="0">
                                </p-dropdown>
                            </span> -->
                            <!-- <app-filters></app-filters> -->
                            <span class="p-mr-2 group-by-wrapper">
                                <button icon="pi pi-tags" pButton pRipple type="button"
                                    class="p-button-secondary p-button-text"
                                    (click)="groupby.toggle($event);showGroupBy()" pTooltip="Group by"
                                    tooltipPosition="top">
                                </button>
                                <span *ngIf="selectedGroupByValue" class="group-by-badge"></span>
                            </span>
                            <app-filters [listCols]="listColsAll"
                                [selectedParentModule]="{name:'Account',objectId:2,channelId:selectedChannelN?.id}"
                                [saveFilterData]="saveFilterData"
                                (applyFiltersColumns)="applyFilters($event)"></app-filters>
                        </ng-template>
                    </p-menubar>
                </div>

                <p-overlayPanel #groupby [showCloseIcon]="true" [style]="{width: '300px'}">
                    <ng-template pTemplate>
                        <label>Group By</label>
                        <p-dropdown [options]="enabledListCols" class="panelDD" [filter]="true"
                            [(ngModel)]="selectedGroupBy" optionLabel="name" placeholder="Select Field">
                        </p-dropdown>
                        <div class="p-text-right p-mt-2">
                            <p-button label="Reset" class="p-button-secondary p-mt-2 p-mr-2"
                                (click)="resetGroup(true);groupby.hide()" [disabled]="!selectedGroupBy"></p-button>
                            <p-button label="Apply" class="p-mt-2" (onClick)="applyGroup();groupby.hide()"
                                [disabled]="!selectedGroupBy"></p-button>
                        </div>
                    </ng-template>
                </p-overlayPanel>

                <div class="p-col-12" *ngIf="savedStepbarN  && isMenuShow && !isDetailsShowing">
                    <div class="card">
                        <div class="p-steps">
                            <ul role="tablist" *ngIf="stagesCountN?.length">
                                <li *ngFor="let stage of stagesCountN; let i = index;">
                                    <a (click)="filterAccountsByStage(i, stage)"
                                        [ngClass]="{'active': selectedStep === (i + 1)}">
                                        <span class="p-steps-number"
                                            [style.background-color]="selectedStep === (i + 1) ? '#9fd037' :
                                            (stage.color && stage.name !== 'All Accounts' && selectedStep != (i + 1) ? stage.color : '#fff')"
                                            [style.color]="stage.color && selectedStep != (i + 1) && stage.name === 'All Accounts' ?
                                                '#000' : '#fff'"
                                            [style.color]="!stage.color && (selectedStep === (i + 1) ? '#fff' : '#000')">
                                            {{ stage.count }}
                                        </span>
                                        <span class="p-steps-title overview-box-name" [style.color]="stage.color && selectedStep === (i + 1) &&
                                            stage.name !== 'All Accounts' ? stage.color : ''"
                                            [style.font-weight]="selectedStep == (i + 1) ? 'bold' : 'normal'">
                                            {{ stage.name }}
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- Body Area -->
                <div class="p-col-12" *ngIf="selectedView == 'list' || selectedView == 'split'">
                    <!-- List and Split View -->
                    <div class="p-grid">
                        <div [class.p-lg-12]="selectedView == 'list'" [class.p-lg-3]="selectedView == 'split'"
                            class="p-col-12" [ngClass]="{'p-d-none': (isLeftTableHide && selectedView == 'split')}">
                            <app-accounts-listing [isDetailsShowing]="isDetailsShowing"
                                [fromUpdateSettings]="fromUpdateSettings" [selectedGroupByValue]="selectedGroupByValue"
                                [contextMenuItems]="contextMenuItems" [selectedView]="selectedView"
                                [savedListCols]="savedListCols" [listColsAll]="listColsAll"
                                [fromGlobalSearch]="fromGlobalSearch" [first]="first" [searchValue]="searchValue"
                                [isFirst]="isFirst" [rowGroupMetadata]="rowGroupMetadata"
                                [selectedFilter]="selectedRecent?.code" [globalSearchData]="globalSearchData"
                                [expandedRows]="expandedRows" [selectedColumn]='selectedColumn'
                                [selectedChannel]="selectedChannelN" [scrollable]="true"
                                [filterInColumns]="filterInColumns" [pageNumber]="pageNumber" [pageSize]="pageSize"
                                [sortByColumnName]="sortByColumnName" [totalRecords]="totalRecords"
                                [noAccountFindOrLoadingText]="noAccountFindOrLoadingText"
                                [isSortByDescending]="isSortByDescending" [selectedActiveStages]="selectedActiveStages"
                                [selectedAccount]="selectedAccount" [accountTreeViewEnabled]="accountTreeViewEnabled"
                                [isActive]="isActive" [selectedStageId]="selectedStageId"
                                [showFloatHeader]="showFloatHeader" (rowSelect)="onRowSelect($event)"
                                (rowUnselect)="onRowUnselect()" (refreshList)="refreshList()"
                                (getContextMenuOptions)="getContextMenuOptions($event)"
                                (setSelectedView)="setSelectedView($event)"
                                (getAllAccountsWithPagination)="getAllAccountsWithPagination($event)"
                                [stagesCountN]="stagesCountN" [showActionColumn]="showActionColumn">
                            </app-accounts-listing>
                        </div>

                        <!-- Details View -->
                        <div class="p-col-12 card p-mt-2"
                            [ngClass]="{'p-lg-12': isLeftTableHide, 'p-lg-9': !isLeftTableHide}"
                            *ngIf="selectedView == 'split' && selectedAccount">
                            <app-accounts-full-details [configMenuItems]="contextMenuItems"
                                (getContextMenuOptions)="getContextMenuOptions($event)"
                                (closeSplitView)="closeSplitView(false)" (tabhandleChange)="handleTabChange($event)"
                                [selectedTabIndex]="selectedTabIndex" [savedDetailViewCols]="savedDetailViewCols"
                                [selectedAccountFromTable]="selectedAccountFromTable"
                                [displayAccountDetails]="displayAccountDetails"
                                (onAccountDetailClose)="onAccountDetailClose()"
                                [readContactPermission]="readContactPermission" [contactList]="contactList"
                                (onAddContact)="onAddContact($event)" [addUpdateDone]="addUpdateDone"
                                [hasChildAccounts]="hasChildAccounts"
                                [noContactFindOrLoadingText]="noContactFindOrLoadingText"
                                (postContactEdit)="postContactEdit()" (getAllContact)="getAllContacts()"
                                [objectTypeId]="objectTypeId" [isMenuShow]="isMenuShow"
                                [isLeftTableHide]="isLeftTableHide" [objectId]="objectId" [stagesCountN]="stagesCountN"
                                (reloadDetails)="completeAccountEdit($event?.id)" (hideMenu)="hideMenu($event)"
                                (showMenu)="showMenu($event)" (showFloathead)="showFloathead()"
                                (hideFloathead)="hideFloathead()"></app-accounts-full-details>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>



<app-lion-activity-sidebar *ngIf="selectedView == 'list'" [objectId]="2" [objectType]="'Account'">
</app-lion-activity-sidebar>

<!-- Account Add/View Component -->
<app-add-view-account *ngIf="displayAddView" [displayAddView]="displayAddView" [isAdd]="isAdd" [isEdit]="isEdit"
    [objectId]="objectId" [editPermission]="editPermission" [selectedChannel]="selectedChannelN"
    [accountInfoCustom]="accountInfoCustom" [selectedAccount]="selectedAccount" [stages]="stagesCountN"
    [selectedStage]="selectedStage" [savedDetailViewCols]="savedDetailViewCols"
    (completeAccountAdd)="completeAccountAdd($event)" (completeAccountEdit)="completeAccountEdit($event)"
    (closeModal)="closeModal()" [isCopyAccount]="isCopyAccount"
    [currentSelectedAccountChannelIdForCopy]="currentSelectedAccountChannelIdForCopy"
    [businessClassificationForCopy]="businessClassificationForCopy">
</app-add-view-account>

<!-- Account Edit Component -->
<app-edit-account *ngIf="displayEditViewDialog" [displayEditViewDialog]="displayEditViewDialog"
    [displayView]="displayView" [selectedAccountId]="selectedAccountId" [selectedView]="selectedView"
    [selectedChannelId]="selectedChannelN?.id" (getAccountListAfterEdit)="getAccountListAfterEdit()"
    (getAccountDetailsAfterEdit)="getAccountDetailsAfterEdit($event)" (closeModal)="closeModal()">
</app-edit-account>

<!-- Account Import Component -->
<app-shared-import-modal *ngIf="displayImport" [displayAddImport]="displayImport" [selectedModuleId]="objectId"
    [selectedChannelId]="selectedChannelN?.id" [disableModuleChange]="true" (dialogClosed)="hideImport()"
    (importStarted)="callListingAfterAdd()">
</app-shared-import-modal>

<app-shared-export-modal-new moduleName="Account" [objectId]="accountObjId" [channelId]="selectedChannelN?.id"
    [stageId]="selectedStageId" [isActive]="isActive" [selectedRecent]="selectedRecent"
    [allListColumns]="allListColumns" [display]="displayExport" (onExportComplete)="onExportCompleted()"
    (cancelClicked)="onExportCompleted()">
</app-shared-export-modal-new>

<app-shared-column-setting-modal [displayColumnSettings]="displayColumnSettings" moduleName="Account"
    [disabledLabelNames]="disabledLabelNames" [settingsObj]="columnSettingsN" [selectedView]="selectedView"
    [channelId]="selectedChannelN?.id" (savedColumnSettings)="savedColumnSettings()"
    (cancelColumnSettings)="cancelColumnSettings()">
</app-shared-column-setting-modal>

<!-- Account Active/Inactive Modal -->
<app-lion-active-inactive-modal *ngIf="displayActiveInactiveModal"
    [displayActiveInactiveModal]="displayActiveInactiveModal" [activeInactiveFormType]="activeInactiveFormType"
    [id]="id" [statusId]="statusId" [moduleName]="moduleName" (saveActiveInactiveModal)="saveActiveInactiveModal()"
    (cancelActiveInactiveModal)="cancelActiveInactiveModal()">
</app-lion-active-inactive-modal>

<!-- Move Account Dialog Modal -->
<app-account-move-dialog *ngIf="displayAccountMoveDialog" [displayAccountMoveDialog]="displayAccountMoveDialog"
    (cancelMoveAccountModal)="cancelMoveAccountModal()" (saveMoveAccountModal)="saveMoveAccountModal($event)"
    [selectedAccountForMove]="selectedAccountForMove" [allAccountChannelListForMove]="channelsN"
    [currentSelectedChannelId]="currentSelectedChannelId">
</app-account-move-dialog>

<app-make-account-copy [displayCopyAccountDialog]="displayCopyAccountDialog" [allAccountChannelListForCopy]="channelsN"
    (openAddForCopy)="openAddForCopy()" (cancelCopyAccountModal)="cancelCopyAccountModal()"
    (selectedAccountChannelIdForCopy)="selectedAccountChannelIdForCopy($event)"></app-make-account-copy>

<!-- Check In Modal -->
<p-dialog [(visible)]="displayCheckInPopup" [modal]="true" [closable]="false" [style]="{width: '20vw'}">
    <ng-template pTemplate="content">
        <div class="p-field p-grid" style="text-align: center;">
            <div class="p-col-12">
                <p>Office Phone</p>
                <label style="font-size: 15px;">Check in?</label>
                <div class="p-d-flex p-jc-center" style="margin-top: 1.5rem;">
                    <p-button label="No" (click)="displayCheckInPopup = false;" class="p-mr-4"></p-button>
                    <p-button label="Yes" (click)="loadQuestionnaireQuestions()"></p-button>
                </div>
            </div>
        </div>
    </ng-template>
</p-dialog>

<!-- Questionnaire Modal -->
<lion-questionnaire-modal moduleName="Account" *ngIf="displayQuestionnairePopup" [display]="displayQuestionnairePopup"
    [questionnairData]="questionnaires" [visitData]="visits" (cancelClicked)="onCancelQuestionnaire()"
    (onCheckout)="onCheckoutQuestionnaire()">
</lion-questionnaire-modal>

<!-- Mass Edit -->
<app-shared-mass-edit *ngIf="displayMassEdit" [displayMassEdit]="displayMassEdit" (closeDialog)="closeMassEdit()"
    [selectedChannel]="selectedChannelN"></app-shared-mass-edit>

<p-toast position="top-right" [baseZIndex]="10000"></p-toast>
<p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>

